import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
// 添加全局样式
import './assets/css/global.css'

// 导入axios
import axios from 'axios'
// 挂载axios
Vue.prototype.$http = axios
// 设置访问根路径
// axios.defaults.baseURL = "http://localhost:9000"
//axios.defaults.baseURL = "http://localhost:9000/visitorspring"
axios.defaults.baseURL = "https://i.sdyu.edu.cn/visitorspring"

import store from './store'


router.beforeEach((to,from,next) => {
  if(to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


